import React, { useEffect, useRef, useState } from 'react';
import { CountryLists } from 'assets/helperdata/country-lists';

export function CountriesUIFlag ({ countryName }) {
    
    const [countries, setCountries] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState(null);

    useEffect(() => {
        if (CountryLists && CountryLists.length > 0) {
            setCountries(CountryLists);
            const foundCountry = CountryLists.find(country => country.name === countryName);
            if (foundCountry) {
                setSelectedCountry(foundCountry);
            } else {
                setSelectedCountry(null);
            }
        }
    }, []);

    return (
        <div>
            {selectedCountry && (
                <div>
                    {selectedCountry?.flag}
                    {/* <h3>{selectedCountry.name}</h3>
                    <p>Code: {selectedCountry.code}</p> */}
                </div>
            )}
        </div>
    );
};

export function CountriesUIFlagName ({ countryName }) { 
    
    const [countries, setCountries] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState(null);

    useEffect(() => {
        if (CountryLists && CountryLists.length > 0) {
            setCountries(CountryLists);
            const foundCountry = CountryLists.find(country => country.name === countryName);
            if (foundCountry) {
                setSelectedCountry(foundCountry);
            } else {
                setSelectedCountry(null);
            }
        }
    }, []);

    return (
        <div>
            {selectedCountry && (
                <div className="flex gap-2 align-items-center">
                    <div>{selectedCountry?.flag}</div>
                    <div>{selectedCountry.name}</div>
                </div>
            )}
        </div>
    );
};

